module.exports = __webpack_public_path__ + "img/cover_photo.c6ee46bf.jpg";